package com.yogaaicoach.pages.trainingprogram

import com.yogaaicoach.common.ui.components.*
import com.yogaaicoach.scope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.useEffectOnce
import react.useState
import web.cssom.ClassName

internal external interface AddNewTrainingScreen2PageProps : Props {
    var viewModel: AddNewTrainingViewModel
    var onNextButtonClicked: () -> Unit
}

private data class LevelContent(val key: LevelKey, val title: String, val image: String, val description: String)

private val levelContents = listOf(
    LevelContent(
        LevelKey.ABSOLUTE_BEGINNER,
        "Absolute Beginner",
        "absolute_beginner.jpg",
        "For those completely new to yoga, covering fundamental poses and breathing techniques."
    ),
    LevelContent(
        LevelKey.ADVANCED_BEGINNER,
        "Advanced Beginner",
        "advanced_beginner.jpg",
        "For those who have a basic understanding but need more guidance in developing their practice."
    ),
    LevelContent(
        LevelKey.INTERMEDIATE,
        "Intermediate",
        "intermediate.jpg",
        "For those who are comfortable with the basics and ready to explore more challenging poses and sequences."
    ),
    LevelContent(
        LevelKey.ADVANCED_INTERMEDIATE,
        "Advanced Intermediate",
        "advanced_intermediate.jpg",
        "For those who have a solid practice and are ready to refine their technique and explore advanced poses."
    ),
    LevelContent(
        LevelKey.ADVANCED,
        "Advanced",
        "advanced.jpg",
        "For experienced practitioners who are looking to deepen their practice with complex poses and sequences."
    ),
)

// Pixel-matched against AddNewTrainingScreen2.kt: same row chrome as Screen 1, but no
// bottomContent — clicking a row both selects it and immediately advances (LazyPageLayout with
// no Next button), so there's no .wizard-page-has-bottom-bar reserved space here. Selection is
// still tracked (not just fired-and-forgotten) so the previously picked level shows highlighted
// if the user navigates back here from Screen 3, same as the real source's mutated Level list.
internal val AddNewTrainingScreen2Page = FC<AddNewTrainingScreen2PageProps> { props ->
    var selectedLevel by useState(props.viewModel.selectedLevel.value)

    useEffectOnce {
        scope.launch { props.viewModel.selectedLevel.collect { selectedLevel = it } }
    }

    div {
        className = ClassName("wizard-page")

        StepProgressIndicator(2, listOf(CenterFocusStrongIcon, TrendingUpIcon, PersonIcon, CalendarMonthIcon))

        PageTitleSection(
            "What's your current level?",
            "This helps us design a training program that's safe, effective, and perfectly aligned with your experience."
        )

        div {
            className = ClassName("wizard-list")
            levelContents.forEach { content ->
                AddTrainingRow(content.image, content.title, content.description, selectedLevel == content.key) {
                    props.viewModel.selectLevel(content.key)
                    props.onNextButtonClicked()
                }
            }
        }
    }
}
